<template>
  <div id="patient_form">
    <div class="vx-row">
      <div class="vx-col w-1/2 mt-2 mb-2 flex">
        <vx-card title="Detail Order">
           <vs-row class="mt-4">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
               <vs-select
                 autocomplete
                 class="w-1/2"
                 name="priority"
                 placeholder="Pilih Prioritas"
                 v-model="priority"
                 label="Prioritas"
                 :disabled="action!=='Update'"
                 >
                 <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listPriority" />
               </vs-select>

               <vs-select
                  autocomplete
                  class="w-1/2 ml-4"
                  name="visitType"
                  placeholder="Pilih Tipe Kunjungan"
                  v-model="visitType"
                  label="Tipe Kunjungan"
                  :disabled="action!=='Update'"
                  >
                  <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listVisitType" />
                </vs-select>
              </vs-col>
           </vs-row>
           <vs-row class="mt-4">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
                <vs-select
                   autocomplete
                   class="w-1/2"
                   name="ward"
                   placeholder="Pilih Ruangan"
                   v-model="ward"
                   label="Ruangan"
                    :disabled="action!=='Update'"
                   >
                   <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listWard" />
                 </vs-select>
                 <!--vs-input name="ward" label="Ruangan" class="w-1/2" v-model="ward" :disabled="action!=='Update'"/-->

                 <vs-select
                    autocomplete
                    class="w-1/2 ml-4"
                    name="insurer"
                    placeholder="Pilih Penjamin"
                    v-model="insurer"
                    label="Penjamin"
                    :disabled="action!=='Update'"
                    >
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listInsurer" />
                  </vs-select>
              </vs-col>
           </vs-row>
           <vs-row>
             <vs-col class="w-full">
                 <span
                     class="text-danger text-sm w-1/2"
                     v-show="ward == '' && validate"
                     >Ruangan harus diisi</span>
              </vs-col>
           </vs-row>
           <vs-row class="mt-4">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
                <!--vs-input name="atensiDescr" label="Atensi Note" class="w-1/2" v-model="atensiDescr" :disabled="action!=='Update'"/-->
                <vs-select
                   autocomplete
                   class="w-full"
                   name="physician"
                   placeholder="Pilih DPJP"
                   v-model="physician"
                   label="Dokter DPJP"
                   :disabled="action!=='Update'"
                   >
                   <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listPhysicians" />
                 </vs-select>
              </vs-col>
           </vs-row>
        </vx-card>
      </div>
      <div class="vx-col w-1/2 mt-2 mb-2 flex">
       <vx-card>
         <div class="vx-row" v-if="action==='Update'">
           <div class="vx-col w-full mt-2 mb-2 flex">
             <vs-select
               autocomplete
               class="w-full"
               name="test"
               placeholder="Cari Test/Pemeriksaan (Paket)"
               v-model="test"
               >
               <vs-select-item :key="index" :value="item.parameter" :text="item.parameterName" v-for="(item,index) in listTest" />
             </vs-select>
           </div>
         </div>
         <vs-divider position="center">
           Test / Pemeriksaan
         </vs-divider>
         <div class="vx-row">
           <div class="vx-col w-full mt-2 mb-2">
            <vs-table stripe :data="listTestPatient" noDataText="Tidak Ada Data" style="text-align:center; max-height:320px; overflow:scroll">
                <template slot="thead">
                    <vs-th>No</vs-th>
                    <vs-th>Test/Pemeriksaan</vs-th>
                    <vs-th v-if="action==='Update'">&nbsp;</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            {{indextr+1}}
                        </vs-td>
                        <vs-td style="width:80%">
                            {{(data[indextr]?data[indextr].parameterName:'')}}
                        </vs-td>
                        <vs-td v-if="action==='Update'">
                            <vs-button radius style="cursor: pointer;" @click="openConfirm(indextr)" color="danger" icon="delete"></vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
           </div>
         </div>
       </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import patient from "@/api/patient";
import master from "@/api/master";
import test from "@/api/test";
import moment from 'moment';

export default {
  components: {
    Datepicker
  },
  props: ['dataPatient', 'subm', 'action', 'from'],
  data() {
    return {
      test: '',
      patient: '',
      patientName: '',
      patientMR: '',
      patientBirthdate: null,
      patientAge: '',
      patientSex: '',
      visitType: '',
      priority: 1,
      ward: '',
      insurer: '',
      physician: '',
      atensiDescr: '',
      listPatient: [],
      listPriority: [],
      listVisitType: [],
      listWard: [],
      listInsurer: [],
      listPhysicians: [],
      listTest: [],
      listTestPatient: [],
      model: {},
      inputIsVisible: false,
      validate: false
    };
  },
  methods: {
    openConfirm(idx) {
      this.listTestPatient.splice(idx, 1);
    },
    async searchPatient(event) {
      if (event.target.value.length > 2) {
			    this.model["keyword"] = event.target.value;
          const frms = await patient.listPatient(this.model);
          var tmpArr = [];
          for (var i = 0; i < frms.data.data.length; i++) {
            var tmp = {}, xdate = '', tmpAge = '';
            if (frms.data.data[i].dob) {
              xdate = new Date(frms.data.data[i].dob);

              var a = moment(xdate);
              var b = moment();

              var years = b.diff(a, 'year');
              a.add(years, 'years');

              var months = b.diff(a, 'months');

              if (Number(months) > 0) {
                tmpAge = years+ '.' + months;
              } else {
                tmpAge = years;
              }
            }

            tmp.value= frms.data.data[i].id;
            tmp.text= frms.data.data[i].patientNumber+'_'
              +frms.data.data[i].name+'_'
              +(xdate!==''?moment(xdate).format('DD-MMM-YYYY'):'')+'_'
              +(frms.data.data[i].genderId==1?'L':'P')

            tmp.name= frms.data.data[i].name;
            tmp.nomr= frms.data.data[i].patientNumber;
            tmp.age= tmpAge;
            tmp.gender= frms.data.data[i].genderId;
            tmp.bod= xdate;

            tmpArr.push(tmp);
          }
          this.listPatient = tmpArr;
      }
    },
    async getMasterData() {
      this.listPriority = JSON.parse(localStorage.getItem("listPriority"));
      this.listVisitType = JSON.parse(localStorage.getItem("listVisitType"));
      this.listInsurer= JSON.parse(localStorage.getItem("listInsurer"));
      this.listWard= JSON.parse(localStorage.getItem("listWard"));
      this.listPhysicians= JSON.parse(localStorage.getItem("listPhysicians"));
      var frms = null;
      if (this.from==='QueueClinic') {
        frms = JSON.parse(localStorage.getItem("listAvailableTestClinic"));
      } else {
        frms = JSON.parse(localStorage.getItem("listAvailableTestPCR"));
      }

      this.listTest= frms;
    },
    validation() {
      this.validate=true;
    }
  },
  computed: {
  },
  watch: {
    test: function(val) {
      let obj = this.lodash.find(this.listTest, o => {
        return o.parameter === val;
      });

      if (obj) {
        this.listTestPatient.push(obj);
      }
    },
    physician: function(val) {
      this.$emit('physician', val);
    },
    ward: function(val) {
      this.$emit('ward', val);
    },
    insurer: function(val) {
      this.$emit('insurer', val);
    },
    priority: function(val) {
      this.$emit('priority', val);
    },
    visitType: function(val) {
      this.$emit('patientType', val);
    },
    listTestPatient: function(val) {
      this.$emit('listTestPatient', val);
    },
    subm: function() {
      this.validation();
    }
  },
  mounted() {
    if (this.dataPatient) {
      this.patientName =  this.dataPatient.patient.name;
      this.patientMR = this.dataPatient.patient.patientNumber;
      var tmp = {}, xdate = '', tmpAge = '';
      if (this.dataPatient.patient.dob) {
        xdate = new Date(this.dataPatient.patient.dob);

        var a = moment(xdate);
        var b = moment();

        var years = b.diff(a, 'year');
        a.add(years, 'years');

        var months = b.diff(a, 'months');

        if (Number(months) > 0) {
          tmpAge = years+ '.' + months;
        } else {
          tmpAge = years;
        }
      }
      this.patientBirthdate = (xdate!==''?moment(xdate).format('DD-MMM-YYYY'):'');
      this.patientAge = tmpAge + ' tahun';
      this.patientSex = (this.dataPatient.patient.gender?this.dataPatient.patient.gender.name:'');
      this.priority = this.dataPatient.priority.id;
      this.visitType = this.dataPatient.patientType.id;
      this.ward = this.dataPatient.ward.id;
      this.insurer = this.dataPatient.insurer.id;
      this.physician = this.dataPatient.physician.id;
      this.listTestPatient = (this.dataPatient.wrap?this.dataPatient.wrap.measures:this.dataPatient.groupTest);
    }
  },
  created() {
    this.getMasterData();
  }
};
</script>
